import { defineMessages } from 'react-intl';

export default defineMessages({
  marketingConsentPromptText: {
    id: 'marketing.consent.text',
    defaultMessage: 'Yes! Send me news and offers from Atlassian about products, events, and more.',
    description: '',
  },
});
